<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <div v-if="isSmartphoneOS" slot="fixed" class="mb-3">
        <div class="top-44px w-100">
          <cm-messages-filter
              ref="filter"
              v-if="serviceId === services.PAYMENTS && mode === 2"
              class="researchfilter position-relative z-10"
              isPayments
              received
              filterType="group"
              :mode="mode"
              @extractCSV="extractCSV(inboxMessages)"
              @applyFilter="applyFilter($event)"
              @refreshInbox="refreshInbox()"
          >
          </cm-messages-filter>
          <cm-messages-filter
              ref="filter"
              v-else
              class="researchfilter position-relative z-10"
              isPayments
              received
              filterType="list"
              :mode="mode"
              @extractCSV="extractCSV(inboxMessages)"
              @applyFilter="applyFilter($event)"
              @refreshInbox="refreshInbox()"
          >
          </cm-messages-filter>
        </div>
      </div>
      <div class="listPage">
        <!-- <b-row
            class="form-group justify-content-start"
            v-if="false"
        >
          <b-col cols="1">
            <b-button
                class="btn"
                :disabled="activateSpinner"
                @click="refreshInbox()"
            >
              <i class="fa-light fa-rotate-right"></i>
              <span class="fab-label">{{ $t("common.rfrsh") }}</span>
            </b-button>
          </b-col>
          <b-col cols="1" offset-md="6">
            <b-button variant="primary"
                      :disabled="activateSpinner"
                      @click="extractCSV()"
            >
              <i class="fa-light fa-upload"></i>
              <span class="fab-label">{{ $t("common.extract") }}</span>
            </b-button>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                    ref="filter"
                    v-if="serviceId === services.PAYMENTS && mode === 2"
                    class="researchfilter position-relative z-10"
                    isPayments received
                    filterType="group"
                    :mode="this.mode"
                    :randomId="randomId"
                    @extractCSV="extractCSV(inboxMessages)"
                    @applyFilter="applyFilter($event)"
                    propedServiceId="1"
                    @refreshInbox="refreshInbox()">
                </cm-messages-filter>
                <cm-messages-filter
                    ref="filter"
                    v-else
                    class="researchfilter position-relative z-10"
                    isPayments received
                    filterType="list"
                    :mode="this.mode"
                    :randomId="randomId"
                    @extractCSV="extractCSV(inboxMessages)"
                    @applyFilter="applyFilter($event)"
                    propedServiceId="1"
                    @refreshInbox="refreshInbox()">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :class="customMobileLayoutStyle"></div>
            </div>
            <spinner v-if="activateSpinner"></spinner>
            <div v-else>
              <b v-if="hasResult">{{$t('common.monitoring.following_statistics_from_perimeter')}} :</b>
              <div v-if="nbRTP"><span>{{nbRTP}} {{ $t('common.monitoring.RTP-001') }}</span></div>
              <div v-if="nbCreditNotes"><span>{{nbCreditNotes}} {{ $t('common.monitoring.RTP-007') }}</span></div>
              <graph-by-status v-if="hasResult"
                :showAmountNotNumber="showingStatus"
                :datasetData="statusGraph">
              </graph-by-status>
              <b-table striped hover fixed selectable
                v-if="hasResult"
                class="mt-3"
                :key="resetFields"
                :items="items"
                :fields="fields"
                :sort-by="sortField"
                @row-selected="checkList"
                ref="tableSuppliersList">
                <template #cell(rtpi)="data" class="py-2"><span class="dot m-1" :class="'dot'+data.value"></span>{{ $t('filter.feature.'+data.value) }}</template>
                <template #cell(count)="data" class="py-2">{{ data.value }}</template>
                <template #cell(percent)="data" class="py-2">{{ data.value }}</template>
              </b-table>
              <div class="d-flex justify-content-center mt-5" v-else><b>{{ $t('common.no_result')}}</b></div>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>

import * as R from 'ramda'

import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'

import graphByDateStatus from '@/pages/statistics/components/GraphByDateStatus.vue'
import graphByStatus from '@/pages/statistics/components/GraphByStatus.vue'
import graphByDocumentStatus from '@/pages/statistics/components/GraphByDocumentStatus.vue'
import graphByBalance from '@/pages/statistics/components/GraphByBalance.vue'
import graphByContact from '@/pages/statistics/components/GraphByContact.vue'
import graphPanel from '@/pages/statistics/components/GraphPanel.vue'
import documentSerialize from '@/helpers/documentSerialize.json'
import MPstats from '@/pages/statistics/components/MarketPlace/MPstats.vue'
import CashStats from '@/pages/statistics/components/CashFlow/CashStats.vue'
import services from "@/helpers/services";

import {errorMessageAlert} from '@/helpers/alert'
import MessagesFilter from "@/components/common/Filter/index.vue";
import moment from "moment/moment";
import {downloadFileWithDefinedHeaders} from "@/helpers/download";
import {elements} from "canvg";
import { formatDateTime } from '@/helpers/format'
import {loadPage} from '@/helpers/routing'


export default {
  components: {
    randomId: Math.random().toString(36).substr(2, 10),
    "cm-messages-filter": MessagesFilter,
    'graph-by-date-status': graphByDateStatus,
    'graph-by-status': graphByStatus,
    'graph-by-document-status': graphByDocumentStatus,
    'graph-by-balance': graphByBalance,
    'graph-by-contact': graphByContact,
    'graph-panel': graphPanel,
    'page-outline': PageOutline,
    MPstats,
    CashStats,
    'spinner': Spinner,
  },
  data () {
    return {
      activateSpinner: false,
      amount: true,
      contacts: [],
      contactStatus: [],
      currentFilters: {},
      dates: {},
      demo: true,
      docTypes: [],
      fields : [
        { key: 'RTPI', label: this.$t('common.monitoring.rtpi'), class: 'text-start text-truncate d-flex', tdClass: 'p-3' },
        { key: 'count', label: this.$t('common.monitoring.count'), class: 'text-center text-truncate', tdClass: 'p-3' },
        { key: 'percent', label: this.$t('common.monitoring.percent'), class: 'text-center text-truncate', tdClass: 'p-3' }
      ],
      ibans: [],
      ibanStatus: [],
      items: [],
      mode: 5,
      nbRTP: 0,
      nbCreditNotes: 0,
      pStatus: 'month',
      randomId: Math.random().toString(36).substr(2, 10),
      resetFields: false,
      serviceId: 1,
      services: services,
      showingBalance: true,
      showingContact: true,
      showingStatus: true,
      sortField: '',
      statusGraph: {},
      total: 0
    }
  },
  computed: {
    customMobileLayoutStyle() {
      if (this.serviceId === services.PAYMENTS) {
        return "h-136px;"
      } else {
        return "h-90px;"
      }
    },
    isSuperAdmin () {
      return this.$engine.rights.rightIs('super_admin', true)
    },
    hasResult () {
      let count = 0
      for (const property in this.items) {
        count += this.items[property].count
      }
      return count > 0
    },
    canSeeSRTP () {
      if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '1' && this.$engine.rights.rightIs('rtp_orphan_consult_srtp', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_srtp', true)
      }
    },
    canSeeHRTP () {
      if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '2' && this.$engine.rights.rightIs('rtp_orphan_consult_hrtp', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
      }
    },
    canSeePSD2 () {
      if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '3' && this.$engine.rights.rightIs('rtp_orphan_consult_psd2', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_psd2', true)
      }
    },
    pageTitle () {
      return this.$i18n.t('graph.statistics_by_status')
    }
  },
  created () {
  },
  mounted () {
    this.$bus.$emit('filter-set-value', {name: 'dateBegin', value: moment().format('01/MM/YYYY 00:00:00')})
    let filterConditions = {
      dateBegin: moment().format('01/MM/YYYY 00:00:00'),
      dateEnd: '',
      featureType: '1,2,3,4,5,6,7,8,9,10,11',
      getValues: {},
      section: this.$engine.user.getUserNorm() === '3' ? 2 : 1,
      standard: ""
    }

    switch (this.$engine.user.getUserNorm()) {
      case '1':
      filterConditions.featureType = '2,3,4,5,6,8,9'
        break;
      case '2':
        filterConditions.featureType = '2,3,4,8,10,11'
        break;
      case '3':
        filterConditions.featureType = '10,11'
        break;
    }
    this.applyFilter(filterConditions)
  },
  methods: {
    checkList (feature) {
      let rtpFilters = {
        dateBegin: this.currentFilters.dateBegin,
        dateEnd: this.currentFilters.dateEnd
      }
      this.resetFields = !this.resetFields
      let line = feature[0]
      let role = this.$refs.filter.section === 2 ? 1 : 0 // 1 = out, 0 = in
      if (line.count === 0) {
        return
      }
      this.$engine.services.payments.filter.dateBegin = this.currentFilters.dateBegin
      this.$engine.services.payments.filter.dateEnd = this.currentFilters.dateEnd
      this.$engine.services.payments.filter.role = role
      if (role) {
        switch (line.RTPI) {
          case 'RTPI-002':
            this.$engine.services.payments.filter.status = '6,9,10,11,19,20'
            break
          case 'RTPI-003':
            this.$engine.services.payments.filter.status = '13'
            break
          case 'RTPI-004':
            this.$engine.services.payments.filter.status = '14,15'
            break
          case 'RTPI-010':
            this.$engine.services.payments.filter.status = '22,23,24'
            break
          case 'RTPI-011':
            this.$engine.services.payments.filter.status = '21,25'
            break
          case 'OTHER':
            this.$engine.services.payments.filter.status = '1,5,6,7,9,12'
            if (this.$engine.user.getUserNorm() === '3') {
              this.$engine.services.payments.filter.status += '19,20'
            }
            break
        }
      } else {
        switch (line.RTPI) {
          case 'RTPI-002':
            this.$engine.services.payments.filter.status = '6,9,10,11,19,20'
            break
          case 'RTPI-003':
            this.$engine.services.payments.filter.status = '13'
            break
          case 'RTPI-004':
            this.$engine.services.payments.filter.status = '14,15'
            break
          case 'RTPI-010':
            this.$engine.services.payments.filter.status = '22,23,24'
            break
          case 'RTPI-011':
            this.$engine.services.payments.filter.status = '21,25'
            break
          case 'OTHER':
            this.$engine.services.payments.filter.status = '1,5,6,7,9,12'
            if (this.$engine.user.getUserNorm() === '3') {
              this.$engine.services.payments.filter.status += '19,20'
            }
            break
        }
      }
      this.$bus.$emit('switch-selected-menu', '/rtp/listBack/2/1/0')
      loadPage(this, {url: '/rtp/listBack/2/1/1'})
    },
    getPercent(value){
      let percent
      if (this.total != 0){
        percent = (value/this.total)*100
        return percent.toFixed(2) +' %'
      } else {
        return '0 %'
      }

    },
    extractCSV (inboxMessages) {
      let firstLine =
          this.$t('common.origin') + ';' +
          this.$t('common.date_label') + ';' +
          this.$t('common.global.clearing') + ';' +
          this.$t('common.routing.message') + ';' +
          this.$t('orphan.init_party') + ';' +
          this.$t('requestToPay.msg_id') + ';' +
          this.$t('orphan.flow') + ';' +
          ' \r\n'

      let lines = ''
      let that = this


      this.paginationObject['firstIndex'] = 1
      let filterConditions
      if (this.filterConditions) {
        filterConditions = this.filterConditions
      } else if (Object.keys(this.$engine.services.payments.filter.getDefaultFilter()).length > 0) {
        filterConditions = this.$engine.services.payments.filter.getDefaultFilter()
      } else {
        filterConditions = this.$engine.services.payments.filter.getConditionObject()
      }
      filterConditions.orphelan = '1'
      if (!filterConditions.featureType) {
        let data = firstLine
        that.$f7.hidePreloader()
        const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.pageTitle + '_' + today.unix() + '.csv'
        if (
            that.$f7.device.os === 'android' ||
            that.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(that, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
        that.$f7.alert('', that.$i18n.t('common.exprt_succ'))
        return
      } else {
        filterConditions.featureType = '1,7,' + filterConditions.featureType
      }
      this.$engine.services.payments.messageRTP(
          this.direction,
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
      ).then(resp => {
        let inboxMessagesCSV = {}
        inboxMessagesCSV = resp.data.payments

        for (let datas in inboxMessagesCSV) {
          let origin = inboxMessagesCSV[datas].direction === '1' ? that.$i18n.t('common.snt') : that.$i18n.t('common.rcvd')
          let receptionDate = moment(inboxMessagesCSV[datas].datetime).format(that.$i18n.t('common.datepicker_format_date') + ' HH:mm:ss')
          let clearing = inboxMessagesCSV[datas].standard
          let msgType = this.getMessageTypeLabel(inboxMessagesCSV[datas].messageType)
          let initParty = inboxMessagesCSV[datas].initParty
          let msgId = inboxMessagesCSV[datas].msgId
          let flow = inboxMessagesCSV[datas].type

          lines += origin + ';' +
              receptionDate + ';' +
              clearing + ';' +
              msgType + ';' +
              initParty + ';' +
              msgId + ';' +
              flow + '\r\n'
        }

        let data = firstLine + lines
        that.$f7.hidePreloader()
        const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.pageTitle + '_' + today.unix() + '.csv'
        if (
            that.$f7.device.os === 'android' ||
            that.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(that, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
        that.$f7.alert('', that.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    refreshInbox () {
      this.onRefresh()
    },
    onRefresh () {
      let that = this

      let typeFeatureArray = []
      for (let property in this.$refs.filter.featureList) {
        let type = this.$refs.filter.featureList[property]
        if(type.state === 1) {
          typeFeatureArray.push(type.id)
        }
      }

      let featureType = typeFeatureArray.join(',')
      let filterConditions = {
        "dateBegin": formatDateTime(this.$refs.filter.dateBegin),
        "dateEnd": formatDateTime(this.$refs.filter.dateEnd),
        "section": this.$refs.filter.section,
        "featureType": featureType,
      }

      that.activateSpinner = true
      if (this.canSeeSRTP && !this.canSeeHRTP && !this.canSeePSD2 && !this.isSuperAdmin) {
        filterConditions.standard = '1'
      } else if (!this.canSeeSRTP && this.canSeeHRTP && !this.canSeePSD2 && !this.isSuperAdmin) {
        filterConditions.standard = '2'
      } else if (!this.canSeeSRTP && !this.canSeeHRTP && this.canSeePSD2 && !this.isSuperAdmin) {
        filterConditions.standard = '3'
      } else if (this.isSuperAdmin) {
        filterConditions.standard = filterConditions.standard
      }

      filterConditions.status = ''
      filterConditions.messageType = ''

      filterConditions.standard = this.isSuperAdmin ? filterConditions.Norm : filterConditions.standard
      filterConditions.orphelan = '1'

      this.fields = [
        { key: 'RTPI', label: this.$refs.filter.section === 1 ? this.$t('common.monitoring.rtpi') : this.$t('common.monitoring.rtpo'), class: 'text-start text-truncate d-flex', tdClass: 'p-3' },
        { key: 'count', label: this.$t('common.monitoring.count'), class: 'text-center text-truncate', tdClass: 'p-3' },
        { key: 'percent', label: this.$t('common.monitoring.percent'), class: 'text-center text-truncate', tdClass: 'p-3' }
      ]

      if (!filterConditions.featureType) {
        that.statusGraph = {}
        that.items = []
        that.activateSpinner = false
        that.nbRTP = 0
        that.nbCreditNotes = 0
        return
      } else {
        filterConditions.featureType = '1,7,' + filterConditions.featureType
      }
      this.$engine.monitoring.fetchPromise(filterConditions)
          .then(resp => {
            let newItems = []
            that.total = 0
            let rtpStatus = _.cloneDeep(resp.data.rtp[0])
            that.nbRTP = rtpStatus['RTPI-001']
            that.nbCreditNotes = rtpStatus['RTPI-007']
            delete rtpStatus['RTPI-001']
            delete rtpStatus['RTPI-007']
            that.total = that.nbRTP + that.nbCreditNotes
            Object.entries(rtpStatus).forEach(element => {
              if (!['RTPI-001','RTPI-007'].includes(element[0])) {
                let percent = that.getPercent(element[1])
                newItems.push({'RTPI':element[0], 'count':element[1], 'percent': percent})
              }
            })
            let missingNo = that.total
            if (newItems.length) {
              missingNo -= newItems.map(elem => elem.count).reduce((a, b) => a + b)
            }
            rtpStatus.OTHER = missingNo
            newItems.push({'RTPI':'OTHER', 'count': missingNo, 'percent': that.getPercent(missingNo)})
            that.items = newItems
            that.statusGraph = rtpStatus
            that.activateSpinner = false
          })
          .catch(err => {
            errorMessageAlert(err, that)
            that.activateSpinner = false
          })
    },
    applyFilter (filterConditions) {
      let that = this
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }
      this.filterConditions = filterConditions
      if (filterConditions.dateBegin) {
        filterConditions.dateBegin = formatDateTime(filterConditions.dateBegin)
      }
      if (filterConditions.dateEnd) {
        filterConditions.dateEnd = formatDateTime(filterConditions.dateEnd)
      }
      this.pageCounter = 0
      this.activateSpinner = true
      if (this.canSeeSRTP && !this.canSeeHRTP && !this.canSeePSD2 && !this.isSuperAdmin) {
        filterConditions.standard = '1'
      } else if (!this.canSeeSRTP && this.canSeeHRTP && !this.canSeePSD2 && !this.isSuperAdmin) {
        filterConditions.standard = '2'
      } else if (!this.canSeeSRTP && !this.canSeeHRTP && this.canSeePSD2 && !this.isSuperAdmin) {
        filterConditions.standard = '3'
      } else if (this.isSuperAdmin) {
        filterConditions.standard = filterConditions.standard
      }
      filterConditions.status = ''
      filterConditions.messageType = ''

      this.fields = [
        { key: 'RTPI', label: this.$refs.filter.section === 1 ? this.$t('common.monitoring.rtpi') : this.$t('common.monitoring.rtpo'), class: 'text-start text-truncate d-flex', tdClass: 'p-3' },
        { key: 'count', label: this.$t('common.monitoring.count'), class: 'text-center text-truncate', tdClass: 'p-3' },
        { key: 'percent', label: this.$t('common.monitoring.percent'), class: 'text-center text-truncate', tdClass: 'p-3' }
      ]
      filterConditions.orphelan = '1'
      this.currentFilters = filterConditions
      if (!filterConditions.featureType) {
        that.statusGraph = {}
        that.items = []
        that.activateSpinner = false
        that.nbRTP = 0
        that.nbCreditNotes = 0
        return
      } else {
        filterConditions.featureType = '1,7,' + filterConditions.featureType
      }
      this.$engine.monitoring.fetchPromise(filterConditions)
      .then(resp => {
        let newItems = []
        that.total = 0
        let rtpStatus = _.cloneDeep(resp.data.rtp[0])
        that.nbRTP = rtpStatus['RTPI-001'] ? rtpStatus['RTPI-001'] : 0
        that.nbCreditNotes = rtpStatus['RTPI-007'] ? rtpStatus['RTPI-007'] : 0
        delete rtpStatus['RTPI-001']
        delete rtpStatus['RTPI-007']
        that.total = that.nbRTP + that.nbCreditNotes
        Object.entries(rtpStatus).forEach(element => {
          if (!['RTPI-001','RTPI-007'].includes(element[0])) {
            let percent = that.getPercent(element[1])
            newItems.push({'RTPI':element[0], 'count':element[1], 'percent': percent})
          }
        })
        let missingNo = that.total
        if (newItems.length) {
          missingNo -= newItems.map(elem => elem.count).reduce((a, b) => a + b)
        }
        rtpStatus.OTHER = missingNo
        newItems.push({'RTPI':'OTHER', 'count': missingNo, 'percent': that.getPercent(missingNo)})
        that.items = newItems
        that.statusGraph = rtpStatus
        that.activateSpinner = false
      })
      .catch(err => {
        errorMessageAlert(err, that)
        this.activateSpinner = false
      })
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },

  }
}
</script>
